<template>
  <dialog :open="isOpen === true" class="modal">
    <div class="modal-box w-11/12 max-w-lg">
      <h3 class="font-bold text-lg mb-4">{{ isEditing === true ? 'Edit Button' : 'Add New Button' }}</h3>
      
      <form @submit.prevent="handleSaveChanges">
        <div class="form-control mb-4">
          <label class="label">
            <span class="label-text">Button Label</span>
          </label>
          <input 
            type="text" 
            v-model="editableButton.label" 
            class="input input-bordered w-full" 
            placeholder="Enter button text"
            required
          />
        </div>

        <div class="form-control mb-4">
          <label class="label">
            <span class="label-text">Button Type</span>
          </label>
          <select v-model="editableButton.type" class="select select-bordered w-full" @change="handleTypeChange">
            <option value="Text">Text (Sends label as message)</option>
            <option value="Link">Link (Opens a URL)</option>
            <option value="JumpToStep">Jump to Step (Transitions flow)</option>
          </select>
        </div>

        <div v-if="editableButton.type === 'Link'" class="form-control mb-4">
          <label class="label">
            <span class="label-text">Link URL</span>
          </label>
          <input 
            type="url" 
            v-model="editableButton.action" 
            class="input input-bordered w-full" 
            placeholder="https://example.com"
            required
          />
        </div>

        <div v-if="editableButton.type === 'JumpToStep'" class="form-control mb-4">
          <label class="label">
            <span class="label-text">Target Step</span>
          </label>
          <MultiSelect 
            :options="availableSteps"
            v-model="selectedJumpTarget"
            id-field="value"
            label-field="label"
            placeholder="Select target step"
            :max-selections="1"
            :label="''" />
            
        </div>

        <div class="modal-action mt-6">
          <button type="button" class="btn" @click="closeModal">Cancel</button>
          <button type="submit" class="btn">{{ isEditing === true ? 'Save Changes' : 'Add Button' }}</button>
        </div>
      </form>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button @click="closeModal">close</button>
    </form>
  </dialog>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import MultiSelect from './MultiSelect.vue';
import { v4 as uuidv4 } from 'uuid';

const props = defineProps({
  isOpen: { 
    type: Boolean, 
    required: true 
  },
  buttonData: {
    type: Object, 
    default: null 
  },
  availableSteps: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['close', 'save']);

const editableButton = ref({});
const selectedJumpTarget = ref([]);

const isEditing = computed(() => props.buttonData !== null && props.buttonData !== undefined && props.buttonData.id !== undefined);

watch(() => props.isOpen, (newVal) => {
  if (newVal === true) {
    if (isEditing.value === true) {
      editableButton.value = JSON.parse(JSON.stringify(props.buttonData));
      if (editableButton.value.type === 'JumpToStep' && editableButton.value.action !== undefined) {
        selectedJumpTarget.value = [editableButton.value.action];
      } else {
        selectedJumpTarget.value = [];
      }
    } else {
      editableButton.value = {
        id: uuidv4(),
        label: '',
        type: 'Text',
        action: ''
      };
      selectedJumpTarget.value = [];
    }
  }
}, { immediate: true });

watch(selectedJumpTarget, (newTarget) => {
  if (editableButton.value.type === 'JumpToStep') {
    editableButton.value.action = (newTarget !== undefined && newTarget !== null && newTarget.length > 0) ? newTarget[0] : '';
  }
});

function handleTypeChange() {
  editableButton.value.action = '';
  selectedJumpTarget.value = [];
}

function closeModal() {
  emit('close');
}

function handleSaveChanges() {
  if (editableButton.value.label.trim() === '') {
    alert('Button label cannot be empty.');
    return;
  }
  if (editableButton.value.type === 'Link' && editableButton.value.action.trim() === '') {
    alert('Link URL cannot be empty for Link type buttons.');
    return;
  }
  if (editableButton.value.type === 'JumpToStep' && (editableButton.value.action === '' || editableButton.value.action === null)) {
    alert('Target step must be selected for Jump to Step type buttons.');
    return;
  }
  
  emit('save', JSON.parse(JSON.stringify(editableButton.value)));
  closeModal();
}

</script>

<style scoped>
</style> 